// Comparison Table
class ComparisonTable {
	tables = document.querySelectorAll('.comparison-table') || [];

	constructor() {
		for (const table of [...this.tables]) {
			table.offset = { top: 0, height: 0, width: 0 };
			let active;

			table.addEventListener('mousedown', e => {
				e.preventDefault();
				active = table;

				Object.assign(active.dataset, { down: 'true', move: 'false', scrollLeft: active.scrollLeft, x: e.clientX });

				e.stopPropagation();
			});
			table.addEventListener('click', e => {
				if (table.dataset.move === 'true') {
					e.stopPropagation();
				}
			});
			document.addEventListener('mousemove', e => {
				if (active && active.dataset.down === 'true') {
					e.preventDefault();
					const moveX = +active.dataset.x - e.clientX;

					if (moveX !== 0) {
						active.dataset.move = 'true';
						active.scrollLeft = +active.dataset.scrollLeft + moveX;
					}
					e.stopPropagation();
				}
			});
			document.addEventListener('mouseup', e => {
				if (active && active.dataset.down === 'true') {
					active.dataset.down = 'false';
					e.stopPropagation();
				}
			});

			table.addEventListener('scroll', () => this.toggleOverflow(table));
			new ResizeObserver(() => this.toggleOverflow(table)).observe(table);
		}

		this.setHeaderHight();

		window.addEventListener('resize', () => this.setHeaderHight());
		window.addEventListener('scroll', () => this.setHeaderHight());
	};

	generateCssText = table => {
		const array = [];
		for (const [k, v] of Object.entries(table.offset)) {
			array.push(`--offset-${k}: ${v}px;`);
		}
		return array.join(' ');
	};

	setHeaderHight = () => {
		const header = document.querySelector('.site-header').clientHeight || 0;

		for (const table of [...this.tables]) {
			table.offset.top = Math.floor(table.getBoundingClientRect().top - header) * -1;
			table.style.cssText = this.generateCssText(table);
		}
	};

	toggleOverflow = table => {
		const { clientWidth, scrollLeft, scrollWidth } = table;

		Object.assign(table.offset, { height: table.querySelector('table').clientHeight, width: clientWidth });
		table.style.cssText = this.generateCssText(table);

		scrollWidth > clientWidth ? table.classList.add('has-overflow') : table.classList.remove('has-overflow');
		scrollLeft > 0 ? table.classList.add('passing-left') : table.classList.remove('passing-left');
		scrollWidth !== scrollLeft + clientWidth ? table.classList.add('passing-right') : table.classList.remove('passing-right');
	};
};

document.addEventListener('DOMContentLoaded', () => {
	window.ComparisonTable = new ComparisonTable;
});

